function findNearestTextMatch(fullText, selectedText, preferredOffset = 0) {
    const source = String(fullText || '');
    const target = String(selectedText || '');
    if (!target) return -1;

    const requestedStart = Math.max(0, Number(preferredOffset) || 0);
    if (
        source.slice(requestedStart, requestedStart + target.length) === target
    ) {
        return requestedStart;
    }

    let closest = -1;
    let closestDistance = Number.POSITIVE_INFINITY;
    let match = source.indexOf(target);
    while (match >= 0) {
        const distance = Math.abs(match - requestedStart);
        if (distance < closestDistance) {
            closest = match;
            closestDistance = distance;
        }
        match = source.indexOf(target, match + 1);
    }
    return closest;
}

module.exports = { findNearestTextMatch };
